import getValueByDotNotation from './getValueByDotNotation';
import hasAtLeastOneValue from './hasAtLeastOneValue';

const getFieldPermission = ({ field, permissions }) => {
  if (field?.permission) {
    return field?.permission;
  }

  if (field?.permissionName) {
    const permissionValue = getValueByDotNotation(
      permissions,
      field?.permissionName,
    );
    return permissionValue;
  }

  // if a permisson is found
  if (permissions?.[field.name]) {
    if (permissions?.[field.name] === 'WRITE_ONCE') {
      if (field?.initialValue && hasAtLeastOneValue(field.initialValue)) {
        return 'READ';
      }
      return 'WRITE';
    }
    return permissions?.[field.name];
  }

  // static permissions for special form components
  if (field?.control === 'subsection') {
    return 'READ_ONLY';
  }

  // if permission is not found but has no name attribute(like pagesections)
  if (!field?.name) {
    return 'READ_ONLY';
  }

  // Fields that have names but no permissions
  return 'NO_PERMISSION';
};

export default getFieldPermission;
